/*
  Collapsing header on desktop (Nov 2026).
  The whole header block (#MainHeader: announcement bar + header + product nav) stays
  pinned to the top of the screen. On desktop it was ~256px tall, so once the shopper
  scrolls down we add `is-collapsed` and header-collapse CSS (in sections/header.liquid)
  shrinks it to one slim row. Scrolling back near the top restores the full header.

  The header sits in the normal page flow, so shrinking it would make the page jump up.
  To stop that, a bottom margin makes up the difference while it is collapsed.
*/
(function () {
  var header = document.getElementById('MainHeader');
  if (!header) return;

  var desktop = window.matchMedia('(min-width: 992px)');
  var COLLAPSE_AT = 200; // px scrolled before the header shrinks
  var EXPAND_AT = 60; // px from the top before it grows back (gap stops flicker)
  var fullHeight = 0;
  var ticking = false;

  function height() {
    return header.getBoundingClientRect().height;
  }

  // Measure the full-size header with animations off, so a half-finished shrink/grow
  // doesn't give the wrong number. Leaves the collapsed state as it was.
  function measureFull() {
    var wasCollapsed = header.classList.contains('is-collapsed');
    header.classList.add('is-measuring');
    header.classList.remove('is-collapsed');
    fullHeight = height();
    header.classList.toggle('is-collapsed', wasCollapsed);
    height(); // apply the state before animations come back on
    header.classList.remove('is-measuring');
  }

  function setCollapsed(collapsed) {
    if (collapsed === header.classList.contains('is-collapsed')) return;
    if (collapsed) measureFull();
    header.classList.toggle('is-collapsed', collapsed);
    if (!collapsed) header.style.marginBottom = '';
  }

  function update() {
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop;
    if (!desktop.matches) {
      setCollapsed(false);
      return;
    }
    if (y > COLLAPSE_AT) setCollapsed(true);
    else if (y < EXPAND_AT) setCollapsed(false);
  }

  // Keep the page from jumping: while collapsed, margin = full height - current height.
  // Runs on every frame of the shrink/grow animation.
  if ('ResizeObserver' in window) {
    new ResizeObserver(function () {
      if (!header.classList.contains('is-collapsed')) return;
      header.style.marginBottom = Math.max(0, fullHeight - height()) + 'px';
    }).observe(header);
  }

  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    },
    { passive: true }
  );
  if (desktop.addEventListener) desktop.addEventListener('change', update);
  // Full height changes with window width (logo size), so re-measure after a resize.
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (header.classList.contains('is-collapsed')) {
        measureFull();
        header.style.marginBottom = Math.max(0, fullHeight - height()) + 'px';
      }
      update();
    }, 150);
  });
  update();
})();
